import React, { Component } from 'react';
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Time from "../../utils/Time";
import ImageCarouselView from "./ImageCarouselView";
import Text from "../../utils/Text";

export default class ClosedAdvertisementsTableView extends Component {

    static propTypes = {
        advertisements:
        PropTypes.arrayOf(
            PropTypes.shape(
                {
                    advertisementId: PropTypes.number.isRequired,
                    memberId: PropTypes.number.isRequired,
                    title: PropTypes.string.isRequired,
                    description: PropTypes.string.isRequired,
                    statusId: PropTypes.number.isRequired,
                    statusName: PropTypes.string.isRequired,
                    created: PropTypes.number.isRequired,
                    updated: PropTypes.number.isRequired,
                    deleted: PropTypes.bool.isRequired,
                    imageNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
                }
            )
        ).isRequired
    };

    render() {
        if (this.props.advertisements.length === 0) {
            return (
                <div className="text-muted text-center mt-5 mb-5">
                    You currently have no closed Advertisements.
                    <br/>
                    Closed Advertisements can not be reserved to Spaces.
                </div>
            );
        }

        return (
            <div className="d-flex align-content-stretch flex-wrap">
                {
                    this.props.advertisements.map((advertisement) => {
                        return (
                            <div className="col-xs-12 col-md-6 col-lg-4 pt-2" key={"Advert-"+advertisement.advertisementId}>
                                <div className="card rounded h-100">
                                    <ImageCarouselView imageNames={advertisement.imageNames} id={advertisement.advertisementId} viewHeightSize={25}/>
                                    <div className="card-body border-top-box" id={advertisement.advertisementId}>
                                        <div className="row mb-0">
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="btn btn-link pl-0 pr-0"
                                                    onClick={(e) => this.handlePreviewAdvertisementClick(advertisement.advertisementId)}
                                                >
                                                    <h6 className="card-title bold-contents-text">
                                                        {advertisement.title}
                                                    </h6>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="row justify-content-center">
                                            Created:
                                            <span className="pl-2">
                                                {this._convertTimeStampToReadableDateTime(advertisement.created)}
                                            </span>
                                        </div>
                                        <div className="row">
                                            <p className="card-text text-muted">{Text.truncate(advertisement.description, 100, true)}</p>
                                        </div>
                                    </div>
                                    <div className="card-footer p-0">
                                        <div className="btn-group w-100">
                                            <button
                                                type="button"
                                                className="btn btn-cuvered-pink"
                                                onClick={(e) => this.handleEditAdvertisementClick(advertisement.advertisementId)}
                                            >
                                                <i className="fas fa-edit mr-1" />
                                                Edit
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-cuvered-light-blue"
                                                onClick={(e) => this.handleOpenAdvertisementClick(advertisement.advertisementId)}
                                            >
                                                <i className="fas fa-door-open mr-1" />
                                                Open
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }

    handleOpenAdvertisementClick = (advertisementId) => {
        EventPublisher.publish(UIInteractionEvents.OPEN_ADVERTISEMENT_CLICKED, {advertisementId: advertisementId});
    };

    handlePreviewAdvertisementClick = (advertisementId) => {
        EventPublisher.publish(UIInteractionEvents.MY_ADVERTISEMENTS_ADVERTISEMENT_PREVIEW_BUTTON_CLICKED, {advertisementId: advertisementId});
    };

    handleEditAdvertisementClick = (advertisementId) => {
        EventPublisher.publish(UIInteractionEvents.MY_ADVERTISEMENTS_EDIT_ADVERTISEMENT_BUTTON_CLICKED, {advertisementId: advertisementId});
    };

    _convertTimeStampToReadableDateTime(timeStamp) {
        return Time.parseDateFromTimestamp(timeStamp).toLocaleString('en-US');
    }
}
